// Marketing attribution store (docs/decisions/0010-blitz-and-client-side-attribution.md).
// Pages are static (Blitz), so UTMs/click IDs are read here from location.search, never server-side.
// A visit with any tracked param is a new touch: it replaces `last` wholesale and sets `first` once per TTL.
// Kept in a first-party cookie + localStorage (newest wins); works in memory when storage is blocked.
(function() {
    var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
    var NAME = 'wghi_attr';
    var TTL_DAYS = 90;
    var MAX_LEN = 200;

    function clean(value) {
        return String(value).replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, MAX_LEN);
    }

    function externalReferrer() {
        try {
            var ref = document.referrer ? new URL(document.referrer) : null;
            return ref && ref.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '') ? clean(ref.origin + ref.pathname) : '';
        } catch (e) {
            return '';
        }
    }

    function readCookie() {
        try {
            var match = document.cookie.match(new RegExp('(?:^|; )' + NAME + '=([^;]*)'));
            return match ? JSON.parse(decodeURIComponent(match[1])) : null;
        } catch (e) {
            return null;
        }
    }

    function readStorage() {
        try {
            return JSON.parse(window.localStorage.getItem(NAME));
        } catch (e) {
            return null;
        }
    }

    function stamp(state) {
        return state ? Math.max(state.last ? state.last.ts : 0, state.first ? state.first.ts : 0) : 0;
    }

    function write(state) {
        var json = JSON.stringify(state);
        try {
            document.cookie = NAME + '=' + encodeURIComponent(json) + '; max-age=' + (TTL_DAYS * 86400) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
        } catch (e) {}
        try {
            window.localStorage.setItem(NAME, json);
        } catch (e) {}
    }

    // Safari caps script-set cookies at 7 days, so localStorage often outlives the cookie: take the newer one.
    var cookie = readCookie();
    var stored = readStorage();
    var state = (stamp(stored) > stamp(cookie) ? stored : cookie) || {};
    var now = Date.now();
    var expired = function(touch) { return !touch || now - touch.ts > TTL_DAYS * 86400000; };

    var params = {};
    var hasParams = false;
    var search = new URLSearchParams(location.search);
    KEYS.forEach(function(key) {
        var value = search.get(key);
        if ( value && clean(value) ) {
            params[key] = clean(value);
            hasParams = true;
        }
    });

    var referrer = externalReferrer();
    if ( hasParams ) {
        var touch = { params: params, landing_page: clean(location.pathname), referrer: referrer, ts: now };
        state.last = touch;
        if ( expired(state.first) ) {
            state.first = touch;
        }
        write(state);
    } else if ( referrer && state.last ) {
        // Organic/referral return visit: note where it came from but keep the campaign that brought them.
        state.last.referrer = referrer;
        write(state);
    } else if ( referrer && !state.last ) {
        state.last = state.first = { params: {}, landing_page: clean(location.pathname), referrer: referrer, ts: now };
        write(state);
    }

    if ( expired(state.last) ) {
        state = {};
    }

    // Pardot field names differ from the utm_* keys (source, UTM_Campaign, …); both spellings are sent.
    var ALIASES = {
        utm_source: ['source'],
        utm_medium: ['UTM_Medium'],
        utm_campaign: ['UTM_Campaign'],
        utm_term: ['UTM_Term'],
        utm_content: ['UTM_Content'],
    };

    window.wghi = window.wghi || {};
    window.wghi.attribution = {
        // The same map under every Pardot field name, for forms that post to a Pardot form handler (BookingForm.js).
        pardotFields: function() {
            var out = {};
            var flat = this.get();
            Object.keys(flat).forEach(function(key) {
                [key].concat(ALIASES[key] || []).forEach(function(name) {
                    if ( !(name in out) ) out[name] = flat[key];
                });
            });
            return out;
        },
        // Flat map for form URLs: last touch as utm_*, first touch as first_utm_*, plus context.
        get: function() {
            var out = {};
            var last = state.last || {};
            var first = state.first || {};
            KEYS.forEach(function(key) {
                if ( last.params && last.params[key] ) out[key] = last.params[key];
                if ( first.params && first.params[key] ) out['first_' + key] = first.params[key];
            });
            if ( last.landing_page ) out.landing_page = last.landing_page;
            if ( last.referrer ) out.referrer = last.referrer;
            out.page_url = clean(location.origin + location.pathname);
            return out;
        },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'attribution_ready', attribution: window.wghi.attribution.get() });
})();
